"use client"

import { usePathname } from "next/navigation"

import { cn } from "@/lib/utils"
import { useSidebarStore } from "@/stores/sidebar"

import { resolveActiveSidebarHref } from "./active"
import { SIDEBAR_SECTIONS } from "./items"
import { texts } from "./localization/texts"
import { SidebarCollapse } from "./SidebarCollapse"
import { SidebarSearch } from "./SidebarSearch"
import { SidebarSection } from "./SidebarSection"

const sidebarHrefs = SIDEBAR_SECTIONS.flatMap((section) =>
  section.rows.map((row) => row.href)
)

export function Sidebar() {
  const pathname = usePathname() ?? ""
  const isCollapsed = useSidebarStore((state) => state.isCollapsed)
  const activeHref = resolveActiveSidebarHref(pathname, sidebarHrefs)

  return (
    <aside
      id="site-sidebar"
      aria-label={texts.navAria}
      className={cn(
        "mb-2.5 hidden shrink-0 flex-col self-start overflow-hidden rounded-[15px] bg-black-800 xlg:flex",
        isCollapsed ? "w-14" : "w-[290px]"
      )}
    >
      <div
        className={cn(
          "flex flex-col py-4",
          isCollapsed ? "gap-4 px-2" : "gap-4 px-3"
        )}
      >
        <div className="flex flex-col gap-1">
          <SidebarSearch isCollapsed={isCollapsed} />
          <SidebarCollapse isCollapsed={isCollapsed} />
        </div>
        <nav className="flex flex-col" aria-label={texts.navAria}>
          {SIDEBAR_SECTIONS.map((section) => (
            <SidebarSection
              key={section.id}
              section={section}
              isCollapsed={isCollapsed}
              activeHref={activeHref}
            />
          ))}
        </nav>
      </div>
    </aside>
  )
}
